import { ResponsiveTableColumn } from 'modules/shared-components/data-display/table/types';
import { FC } from 'react';
import { useHistory } from 'react-router-dom';
import ErrorBoundary from 'components/error-boundaries';
import Table from 'modules/shared-components/data-display/table';
import { BotType, DexSniperBot } from 'api/types/httpsTypes/dex-bot';
import { thDynamicClass } from './BotsTable';
import { Tabs } from '../../components/layout/SIDEBAR_CONST';

interface Props {
  columnsDef: ResponsiveTableColumn<DexSniperBot>[];
  data: DexSniperBot;
  botType: BotType;
}

export const BotsRow: FC<Props> = ({ data, columnsDef, botType }) => {
  const history = useHistory();
  const tab =
    botType === BotType.Volatility
      ? Tabs.VolatilityBot
      : botType === BotType.Wallet
      ? Tabs.WalletCopyTrading
      : Tabs.TgCopyTrading;
  return (
    <tr
      onClick={() => history.push(`/dex/bots/${tab}/${data.id}/edit`)}
      className="border-t border-dex-black-700 lg:dark:bg-dex-black-800 cursor-pointer items-center hover:dark:lg:bg-dex-black-700 lg:grid lg:grid-cols-11"
    >
      <ErrorBoundary>
        {columnsDef.map((column) => {
          const Column = column.component;
          if (!Column) return;
          return (
            <Table.Td className={thDynamicClass(column.key)} key={column.key}>
              <Column data={data} />
            </Table.Td>
          );
        })}
      </ErrorBoundary>
    </tr>
  );
};
